import { toast } from "react-toastify";
import { QuestionJSON } from "../../../public/Constants/SurveyConstants";

export const STYLE_SWIPE = "Style Swipe";
export const VISIBILITY_CHANGE = "visibilitychange";
export const BEFORE_UNLOAD = "beforeunload";
export const SURVEY_SUMMERY = "Your Survey Summary";
export const SURVEY_SUMMERY_ARABIC = "ملخّص الاستبيان الخاص بكِ";
export const CONTINUE_TEXT = "CONTINUE";

export const SCROLL = "scroll";
export const RESIZE = "resize";
export const BODY_SIZE_SCREEN_TEXT = "Select your body type";

export const extractNumber = (str) => {
    const match = str.match(/\d+/);
    return Number(match ? match[0] : null);
};

export const ValidateScreen = (currentScreen, surveyAnswers, isSima) => {
    let isMandatory = false;
    const mandatoryQuestion = [
        "q1",
        "q2",
        "q3",
        "q4",
        "q5",
        "q6",
        "q7",
        "q8",
        "q9",
        "q10",
        "q11",
        "q13",
        "q14",
        "q15",
        "q24",
        "q25",
        "q26",
        "q27",
        "q29",
        "q30",
        "q36",
        "q45",
        "q47",
        "q48",
        "q49",
        "q50",
        "q51",
        "q52",
        "q53",
        "q55",
        "q56",
        "q57",
        "q58",
        "q59",
        "q60",
        "q62",
        "q64",
        "q65",
        "q67",
        "q68",
    ];
    currentScreen?.questions_list?.map((key) => {
        if (
            Array.isArray(mandatoryQuestion) &&
            mandatoryQuestion.includes(key) &&
            typeof surveyAnswers === "object" &&
            surveyAnswers !== null
        ) {
            const value = surveyAnswers[key];
            if (!Object.prototype.hasOwnProperty.call(surveyAnswers, key)) {
                isMandatory = true;
            } else if (
                value === "" ||
                value === null ||
                value === undefined ||
                (Array.isArray(value) && value.length === 0) ||
                (typeof value === "object" &&
                    !Array.isArray(value) &&
                    Object.keys(value).length === 0)
            ) {
                isMandatory = true;
            }
        }
    });
    if (isMandatory) {
        if (isSima) {
            toast(`!كلما أخبرتنا أكثر، كلما تمكنا من تخصيص مظهرك`, {
                type: "error",
                toastId: "required-toast",
            });
        } else {
            toast(
                `The more you tell us, the more we can personalise your looks!`,
                {
                    type: "error",
                    toastId: "required-toast",
                }
            );
        }
    }
    return !isMandatory;
};

export const formateAnswer = (answer) => {
    const payload = [];
    Object.keys(answer)?.forEach((key) => {
        const ques = QuestionJSON?.[key];
        const ans = answer?.[key];

        let obj = {
            column_name: ques?.db_column,
            input_type: ques?.question_type,
            answer: [],
            media: [],
            size_standard: answer?.screen4 || "",
        };

        if (ans !== "" && key.charAt(0) === "q") {
            if (ques?.db_column === "preference_height") {
                let millimeters;
                const unit = answer[`unit-${key}`];
                if (unit?.id === "ft") {
                    const feetToMillimeters = Number(ans[0]) * 304.8;
                    const inchesToMillimeters = Number(ans.slice(1)) * 25.4;
                    millimeters = feetToMillimeters + inchesToMillimeters;
                } else if (unit?.id === "cm") {
                    millimeters = Number(ans) * 10;
                }
                if (millimeters) {
                    obj.answer = [`${millimeters}`];
                }
            } else if (ques?.db_column === "preference_weight") {
                let grams;
                const unit = answer[`unit-${key}`];
                if (unit?.id === "lb") {
                    grams = Number(ans) * 453.592;
                } else if (unit?.id === "kg") {
                    grams = Number(ans) * 1000;
                }
                if (grams) {
                    obj.answer = [`${grams}`];
                }
            } else if (ques?.db_column === "skin_tone") {
                const selected = ques?.options?.find(
                    (opt) => opt?.image === ans
                );
                if (selected) {
                    obj.answer = [selected?.name].filter(Boolean);
                    obj.media = [selected?.image].filter(Boolean);
                }
            } else if (ques?.db_column === "preference_brands") {
                const answerNames = [];
                const answerImages = [];

                ans?.forEach((val) => {
                    const selectedOption = ques?.options?.find(
                        (opt) => opt?.image === val
                    );
                    if (selectedOption) {
                        if (selectedOption?.name)
                            answerNames.push(selectedOption.name);
                        if (selectedOption?.image) answerImages.push(val);
                    }
                });

                obj.answer = answerNames;
                obj.media = answerImages;
            } else if (ques?.db_column === "body_type") {
                const selected = ques?.options?.find(
                    (opt) => opt?.value === ans
                );
                if (selected) {
                    obj.answer = [selected?.value].filter(Boolean);
                    obj.media = [selected?.image].filter(Boolean);
                }
            } else if (
                ques?.db_column === "preference_dislike_patterns" ||
                ques?.db_column === "preference_dislike_colors"
            ) {
                obj.answer = (ans || []).filter(Boolean);
                const answerImages = [];

                ans?.forEach((val) => {
                    const selectedOption = ques?.options?.find(
                        (opt) => opt?.text === val
                    );
                    if (selectedOption?.image)
                        answerImages.push(selectedOption.image);
                });

                obj.media = answerImages;
            } else if (
                ques?.question_type === "swipe" ||
                ques?.question_type === "swipe-arabic"
            ) {
                obj.media = (ans || [])
                    .map((opt) => opt?.image)
                    .filter(Boolean);
            } else if (
                ques?.question_type === "select" ||
                ques?.question_type === "select-arabic"
            ) {
                if (ans?.value) {
                    obj.answer = [ans.value];
                }
            } else if (ques?.db_column === "dob") {
                const dateArray = ans.split("-");
                if (dateArray.length === 3) {
                    obj.answer = [
                        `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`,
                    ];
                }
            } else if (ques?.db_column === "upload_photos") {
                obj.media = (ans || []).map((opt) => opt?.url).filter(Boolean);
            } else if (Array.isArray(ans)) {
                obj.answer = ans
                    .map((opt) =>
                        typeof opt !== "string" ? opt?.toString() : opt
                    )
                    .filter(Boolean);
            } else {
                if (ans !== undefined && ans !== null && ans !== "") {
                    obj.answer = [ans];
                }
            }

            if (obj.answer.length > 0 || obj.media.length > 0) {
                payload.push(obj);
            }
        }
    });
    return payload;
};

export function formatSurveyData(userSurvey) {
    const formattedData = {
        q37: "",
        q1: "",
        q9: "",
        q10: "",
        screen4: "UK",
        q3: "",
        q4: "",
        q2: "",
        q24: "",
        q25: "",
        q26: "",
        q27: "",
        q5: "",
        q6: "",
        q11: "",
        q12: "",
        "unit-q11": { id: "ft", label: "FT/IN" },
        "unit-q12": { id: "kg", label: "KG" },
        q13: "",
        q14: "",
        q15: [],
        q16: [],
        q17: [],
        q18: [],
        q19: [400, 550],
        q20: [400, 550],
        q21: [400, 550],
        q22: [400, 550],
        q44: [400, 550],
        q23: [400, 550],
        q41: [],
        q28: [],
        swipeCount: 0,
        q30: { value: "", label: "" },
        q31: { value: "", label: "" },
        q29: "",
        q33: "",
        q34: "",
        q35: "",
        q40: [],
        q38: "",
        q36: [],
    };

    // Mapping from column names to formatted keys
    const mapping = {
        landing_reason: "q1",
        skin_tone: "q9",
        body_type: "q10",
        size_tops: "q2",
        size_dresses: "q3",
        size_bottoms: "q4",
        size_jeans: "q24",
        size_bra: "q25",
        size_cup: "q26",
        size_shoes: "q27",
        preference_top: "q5",
        preference_bottom: "q6",
        preference_height: "q11",
        preference_weight: "q12",
        preference_curvy: "q13",
        preference_petite: "q14",
        preference_dislike_colors: "q15",
        preference_dislike_patterns: "q16",
        preference_dislike_fabric: "q17",
        preference_dislike_items: "q18",
        budget_tops: "q19",
        budget_dresses: "q20",
        budget_bottoms: "q21",
        budget_bags: "q22",
        budget_accessories: "q23",
        budget_shoes: "q44",
        preference_brands: "q41",
        style_swipe: "q28",
        nationality: "q30",
        occupation: "q31",
        dob: "q29",
        firstbox_occasions_focus: "q36",
        style_therapist: "q37",
        preference_expecting: "q45",
    };
    const mmToFeetInches = (mm) =>
        `${Math.floor(mm / 25.4 / 12)}  ${Math.ceil((mm / 25.4) % 12)} `;

    const gramsToKgs = (grams) => `${Math.ceil(grams / 1000)}`;

    // Iterate through the userSurvey to populate the formattedData
    const userSurveyData = {};
    userSurveyData.screen4 = userSurvey?.[0]?.size_standard;

    userSurvey?.forEach((item) => {
        const key = mapping?.[item?.column_name];
        if (key) {
            if (Array.isArray(formattedData[key])) {
                userSurveyData[key] = item?.answer;
            } else {
                if (key === "q12") {
                    (userSurveyData["unit-q12"] = { id: "kg", label: "KG" }),
                        (userSurveyData[key] = gramsToKgs(item?.answer?.[0]));
                } else if (key === "q11") {
                    (userSurveyData["unit-q11"] = { id: "ft", label: "FT/IN" }),
                        (userSurveyData[key] = mmToFeetInches(
                            item?.answer?.[0]
                        ));
                } else {
                    userSurveyData[key] = item?.answer?.[0];
                }
            }

            // Handle media for specific keys
            if (key === "q9" && item?.media && item?.media?.length > 0) {
                userSurveyData.q9 = item?.media?.[0];
            } else if (
                key === "q10" &&
                item?.media &&
                item?.media?.length > 0
            ) {
                userSurveyData.q10 = item?.answer?.[0];
            } else if (key === "q28" && item?.media) {
                userSurveyData.q28 = item?.media?.map((url, index) => ({
                    id: `style_swipe_image_${index + 1}`,
                    image: url,
                }));
                userSurveyData.swipeCount = item?.media?.length;
            } else if (key === "q30") {
                userSurveyData.q30 = {
                    value: item?.answer?.[0],
                    label: item?.answer?.[0],
                };
            } else if (key === "q31") {
                userSurveyData.q31 = {
                    value: item?.answer?.[0],
                    label: item?.answer?.[0],
                };
            } else if (key === "q41" && item?.media) {
                // Only add URLs for q41, ignoring other details
                userSurveyData.q41 = item?.media;
            }
        }
    });
    return userSurveyData;
}

export function getScreenData(currentStep) {
    // Ensure currentStep is a valid number, default to 1 if null or invalid
    let step =
        typeof currentStep === "number" && currentStep > 0 ? currentStep : 1;

    // Cap the current step at 16
    step = Math.min(step, 16);

    // Generate the stack of screens up to the (current step - 1)
    const stack = Array.from({ length: step - 1 }, (_, i) => `screen${i + 1}`);

    return {
        current: `screen${step}`,
        direction: -1, // Assuming direction is always backward here, change as needed
        stack: stack,
    };
}

export const getStylePersonality = (QuestionJSON, surveyAnswers) => {
    const styleSwipeKeys = Object.keys(QuestionJSON)?.filter(
        (key) => QuestionJSON?.[key]?.db_column === "style_swipe"
    );

    // Find the selections by prioritizing the last key in the array
    const selections = styleSwipeKeys
        .reverse()
        .find((key) => surveyAnswers?.[key])
        ? surveyAnswers[
              styleSwipeKeys.reverse().find((key) => surveyAnswers?.[key])
          ]
        : [];

    // Check if selections is an array and has at least 5 items
    if (selections?.length < 5) {
        throw new Error("User must select at least 5 images.");
    }
    const counts = {};
    // Count how many times each style personality was selected
    selections?.forEach(({ personality }) => {
        counts[personality] = (counts?.[personality] || 0) + 1;
    });
    // Find the one with the highest count (first one wins ties)
    let maxCount = 0;
    let selectedStyle = null;
    for (const selection of selections) {
        const { personality } = selection;
        if (counts[personality] > maxCount) {
            maxCount = counts?.[personality];
            selectedStyle = personality;
        }
    }
    return selectedStyle;
};
